// credit for this function 👉 https://stackoverflow.com/a/28056903
export const hexToRGB = (hex: string, alpha?: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
    return `rgb(${r}, ${g}, ${b})`;
  }
};

/**
 * credit for this function 👉 https://css-tricks.com/snippets/javascript/lighten-darken-color/
 * @param {*} color hex color
 * @param {*} amt amount to lighten. If amt is a negative number the color will be darkened
 */
export const adjustColor = (color: string, amt: number): string => {
  let usePound = false;

  if (color[0] === '#') {
    color = color.slice(1);
    usePound = true;
  }

  const num = parseInt(color, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

export const withAlpha = (
  hex: string | undefined,
  alpha?: number | undefined,
): string => {
  const r = parseInt(hex?.slice(1, 3) ?? '00', 16);
  const g = parseInt(hex?.slice(3, 5) ?? '00', 16);
  const b = parseInt(hex?.slice(5, 7) ?? '00', 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
    return `rgb(${r}, ${g}, ${b})`;
  }
};

/**
 * @link https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)#stackoverflow-archive-begin
 * @param hexString string ex: "#FF0000"
 * @param percent Float range from 0 - 1
 */
export const shadeHexColor = (
  hexString: string,
  percent: number,
): string | undefined => {
  if (hexString.length !== 7) {
    console.error(
      `Cannot convert brand color value: ${hexString}. Please ensure color includes hash (#) character.`,
    );
    return;
  }

  const f = parseInt(hexString.slice(1), 16);
  const t = percent < 0 ? 0 : 255;
  const p = percent < 0 ? percent * -1 : percent;
  const R = f >> 16;
  const G = (f >> 8) & 0x00ff;
  const B = f & 0x0000ff;

  return (
    '#' +
    (
      0x1000000 +
      (Math.round((t - R) * p) + R) * 0x10000 +
      (Math.round((t - G) * p) + G) * 0x100 +
      (Math.round((t - B) * p) + B)
    )
      .toString(16)
      .slice(1)
  );
};
